import { Link } from "react-router-dom";

import phone_i from "../../../../assets/images/icons/phone.svg";
import search from "../../../../assets/images/icons/search.svg";
import about_i from "../../../../assets/images/icons/about.svg";



export const HeaderNav = ({props}) => {
    return (
       <>
        <div className="header-banner">
            <img src="https://cdn.wallpapersafari.com/99/88/szKPw7.jpg" alt=""  />
        </div>
        <div className="container-fluid h-100">
            <div className="nav-header row h-100">
                <div className="nav-item col-12 h-100">
                    <div className="d-flex flex-column justify-content-center align-items-center h-100" >
                        <div className="title-item">{props?.[0]?.value}</div>
                        <div className="about-item d-flex justify-content-center align-items-center" data-bs-toggle="modal" data-bs-target="#location-modal">
                            <img src={about_i} alt="Про нас" />
                            <span>Про нас</span>
                        </div>
                    </div>
                </div>
                <div className="nav-items position-absolute position-absolute top-0 end-0 mt-3 me-2 d-flex flex-column justify-content-end align-items-end">
                    <Link to={`/search`} className="search-open mb-2">
                        <img src={search} alt="Пошук" />
                    </Link>
                    <div>
                        <a href={`tel:${props?.[2]?.value}`}>
                            <img src={phone_i} alt="Наш номер телефону" />
                        </a>
                    </div>
                    
                </div>
            </div>
        </div>
        </>
        
    )
}